import { useState } from "react";
import { toast } from "react-toastify";
// import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import SelectFieldComponent from "../../../components/common/SelectFieldComponent";
import { adminRoles } from "../../../utils/constants";
import { login } from "../../../services/auth";
import styles from "./Login.module.css";
import logo from "../../../assets/icons/csrl-logo.png";

const Content = styled("div")({
	background: "#fff",
	height: "auto",
	alignSelf: "center",
	padding: "2rem 3rem",
	width: "450px",
	// [theme.breakpoints.down("md")]: {
	// 	marginRight: "auto",
	// },
	// [theme.breakpoints.down("md")]: {
	// 	width: "80vw",
	// 	marginRight: "auto",
	// 	padding: "2rem 1rem",
	// },
	borderRadius: "10px",
});

const Mask = styled("div")({
	position: "absolute",
	background: "rgb(0, 0, 0, 0.1)",
	width: "100%",
	height: "100%",
	display: "flex",
	justifyContent: "center",
});

const BrandLogo = styled("div")({
	display: "flex",
	justifyContent: "center",
	marginBottom: "1rem",
});

const Title = styled("h4")({
	color: "#061e5b",
	textAlign: "center",
	marginBottom: "1rem",
	textTransform: "uppercase",
});

const Form = styled("form")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	"& > *": {
		margin: theme.spacing(1),
		width: "100%",
	},
}));

const Login = () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [role, setRole] = useState("");
	const [showPassword, setShowPassword] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		if (!username) {
			toast.error("Please enter your username");
			return;
		}
		if (!password) {
			toast.error("Please enter your password");
			return;
		}
		const payload = {
			username,
			password,
			role,
		};
		try {
			const { data } = await login(payload);
			localStorage.setItem("token", data.token);
			localStorage.setItem("admin", JSON.stringify(data));
			toast.success("Login successful");
			setLoading(false);
			window.location = "/admin/landing-page";
		} catch (error) {
			setLoading(false);
			if (error.response) {
				toast.error(error.response.data.message);
			} else if (error.request) {
				toast.error("Internal Server Error");
			} else {
				toast.error("Error", error.message);
			}
		}
	};

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	return (
		<div className={styles.login}>
			<Mask>
				<Content>
					<BrandLogo>
						<img src={logo} width="190" height="auto" alt="Brand logo" />
					</BrandLogo>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}
					>
						<Title>KYC Update Admin Portal</Title>
						<Typography
							variant="body1"
							gutterBottom
							sx={{ marginBottom: "1rem", color: "#002564" }}
						>
							Login
						</Typography>
						<Form
							autoComplete="off"
							onSubmit={handleSubmit}
							sx={{ width: "100%" }}
						>
							<SelectFieldComponent
								width="100%"
								values={adminRoles}
								value={role}
								onChange={(e) => setRole(e.target.value)}
								label="Select Role"
								id="role"
								name="role"
								required
								menuValue="value"
								displayValue="name"
							/>
							<TextField
								id="username"
								label="Username"
								variant="outlined"
								value={username}
								onChange={(e) => setUsername(e.target.value)}
								required
								sx={{ marginBottom: "1rem" }}
							/>
							<FormControl variant="outlined">
								<InputLabel htmlFor="password">Password</InputLabel>
								<OutlinedInput
									id="password"
									type={showPassword ? "text" : "password"}
									value={password}
									required
									onChange={(e) => setPassword(e.target.value)}
									endAdornment={
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												onClick={handleClickShowPassword}
												onMouseDown={handleMouseDownPassword}
												edge="end"
											>
												{showPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									}
									label="Password"
								/>
							</FormControl>
							<Button
								disabled={loading}
								variant="contained"
								color="primary"
								sx={{ mt: "1rem" }}
								type="submit"
							>
								{loading ? (
									<CircularProgress size="1.5rem" sx={{ color: "#002564" }} />
								) : (
									"Login"
								)}
							</Button>
						</Form>
					</Box>
				</Content>
			</Mask>
		</div>
	);
};

export default Login;
